export default "__VITE_ASSET__SbxBhWPW__"